import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Sun, UtensilsCrossed, Moon, ChevronDown, ChevronUp, CheckCircle2, Power } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const MEAL_PLAN = [
  {
    day: 'Lunes',
    color: '#3B82F6',
    meals: [
      { type: 'Desayuno', time: '8:00 a.m. en adelante', icon: Sun, items: ['Entre 2 y 3 huevos (al gusto)', 'Queso gouda', 'Cafe o te', 'Jugo verde'] },
      { type: 'Almuerzo', time: '', icon: UtensilsCrossed, items: ['Carne de pollo, pescado o res a la plancha', 'Medio aguacate', 'Pure de papa', 'Media taza de fresas o moras (BERRIES)'] },
      { type: 'Cena', time: '7:30 p.m. a 9:00 p.m.', icon: Moon, items: ['Filete de pescado y/o pollo', 'Ensalada', '1 taza de auyama y/o guineitos'] },
    ],
  },
  {
    day: 'Martes',
    color: '#8B5CF6',
    meals: [
      { type: 'Desayuno', time: '8:00 a.m. en adelante', icon: Sun, items: ['Bullet proof coffee', 'Yogurt griego o kefir', 'Media taza de fresas o moras'] },
      { type: 'Almuerzo', time: '', icon: UtensilsCrossed, items: ['Carne de res, pollo o pescado a la plancha', 'Medio aguacate', 'Pure de yautia'] },
      { type: 'Cena', time: '7:30 p.m. a 9:00 p.m.', icon: Moon, items: ['Res y/o pollo (cualquiera)', 'Una taza de vegetales', 'Postre: semillas de calabaza'] },
    ],
  },
  {
    day: 'Miercoles',
    color: '#10B981',
    meals: [
      { type: 'Desayuno', time: '8:00 a.m. en adelante', icon: Sun, items: ['Entre 2 y 3 huevos (al gusto)', 'Jamon serrano', 'Cafe', 'Jugo verde'] },
      { type: 'Almuerzo', time: '', icon: UtensilsCrossed, items: ['Carne de pollo, pescado o pavo a la plancha', 'Brocoli, coliflor o zanahoria', 'Dos pedazos de guineito'] },
      { type: 'Cena', time: '7:30 p.m. a 9:00 p.m.', icon: Moon, items: ['Filete de pescado y/o cerdo', 'Ensalada', '1 taza de yautia y/o habichuelas o lentejas'] },
    ],
  },
  {
    day: 'Jueves',
    color: '#F59E0B',
    meals: [
      { type: 'Desayuno', time: '8:00 a.m. en adelante', icon: Sun, items: ['Bullet proof coffee', 'Yogurt griego o kefir', 'Media taza de fresas o moras'] },
      { type: 'Almuerzo', time: '', icon: UtensilsCrossed, items: ['Dos yemas de huevo', 'Camarones', 'Ensalada al gusto'] },
      { type: 'Cena', time: '7:30 p.m. a 9:00 p.m.', icon: Moon, items: ['Res y/o pollo', 'Batata al gusto', 'Media taza de fresas', 'Nueces (anacardos, macadamia y/o nueces de brazil)'] },
    ],
  },
  {
    day: 'Viernes',
    color: '#EF4444',
    meals: [
      { type: 'Desayuno', time: '8:00 a.m. en adelante', icon: Sun, items: ['Entre 2 y 3 huevos (al gusto)', 'Jamon serrano', 'Cafe', 'Jugo verde'] },
      { type: 'Almuerzo', time: '', icon: UtensilsCrossed, items: ['Churrasco y/o carne de hamburguesa de pollo', 'Medio aguacate y pico de gallo', 'Postre: Media taza de fresas o moras (BERRIES)'] },
      { type: 'Cena', time: '7:30 p.m. a 9:00 p.m.', icon: Moon, items: ['Filete de pescado y/o cerdo', 'Ensalada', '1 taza de auyama y/o habichuelas o lentejas'] },
    ],
  },
  {
    day: 'Sabado',
    color: '#EC4899',
    meals: [
      { type: 'Desayuno', time: '8:00 a.m. en adelante', icon: Sun, items: ['Bullet proof coffee', 'Yogurt griego o kefir', 'Media taza de fresas o moras'] },
      { type: 'Almuerzo', time: '', icon: UtensilsCrossed, items: ['Dos yemas de huevo', 'Pollo o res (no frito)', 'Medio aguacate', '1/2 taza auyama'] },
      { type: 'Cena', time: '7:30 p.m. a 9:00 p.m.', icon: Moon, items: ['Res y/o aguacate', '1/2 batata', 'Media taza de fresas', 'Nueces (anacardos, macadamia y/o semillas de calabaza)'] },
    ],
  },
  {
    day: 'Domingo',
    color: '#F97316',
    meals: [
      { type: 'Desayuno', time: '8:00 a.m. en adelante', icon: Sun, items: ['Omelette de 3 huevos con jamon y queso', 'Cafe', 'Postre: Media taza de fresas o moras (BERRIES)'] },
      { type: 'Almuerzo', time: '', icon: UtensilsCrossed, items: ['Salmon con vegetales al gusto'] },
      { type: 'Cena', time: '7:30 p.m. a 9:00 p.m.', icon: Moon, items: ['Filete de res y/o pollo', 'Ensalada', 'Pure de papa'] },
    ],
  },
];

const MEAL_COLORS = {
  Desayuno: { bg: 'bg-amber-50', text: 'text-amber-600', border: 'border-amber-100' },
  Almuerzo: { bg: 'bg-emerald-50', text: 'text-emerald-600', border: 'border-emerald-100' },
  Cena: { bg: 'bg-indigo-50', text: 'text-indigo-600', border: 'border-indigo-100' },
};

const ClientNutriPlanPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const basePath = `/${user?.user_type || 'client'}`;
  const [expandedDay, setExpandedDay] = useState('Lunes');
  const [isActive, setIsActive] = useState(false);
  const [activating, setActivating] = useState(false);

  useEffect(() => {
    axios.get(`${API}/diet/active`).then(res => {
      if (res.data.active && res.data.plan_id === 'nutri-plan-nutriquimia') setIsActive(true);
    }).catch(() => {});
  }, []);

  const handleActivate = async () => {
    setActivating(true);
    try {
      await axios.post(`${API}/diet/activate`, { plan_id: 'nutri-plan-nutriquimia' });
      setIsActive(true);
      toast.success('Plan Nutricional activado exitosamente');
    } catch {
      toast.error('Error al activar el plan');
    } finally {
      setActivating(false);
    }
  };

  const toggleDay = (day) => {
    setExpandedDay(prev => prev === day ? null : day);
  };

  return (
    <div className="max-w-2xl mx-auto space-y-5 animate-fade-in pb-8" data-testid="client-nutri-plan-page">
      <button
        onClick={() => navigate(`${basePath}/diet`)}
        className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 transition-colors"
        data-testid="back-to-diet"
      >
        <ArrowLeft size={16} /> Mi Dieta
      </button>

      <div className="pt-1">
        <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
          Plan Nutricional Nutriquimia
        </h1>
        <p className="text-sm text-gray-400 mt-1 font-medium">Tu plan semanal de alimentacion</p>
      </div>

      {/* Activate button */}
      {isActive ? (
        <div className="flex items-center gap-2.5 bg-emerald-50 border border-emerald-200 rounded-2xl px-4 py-3" data-testid="plan-active-badge">
          <CheckCircle2 size={20} className="text-emerald-500 flex-shrink-0" />
          <span className="text-sm font-bold text-emerald-700">Plan activo</span>
        </div>
      ) : (
        <button
          onClick={handleActivate}
          disabled={activating}
          className="w-full flex items-center justify-center gap-2 text-white rounded-2xl py-3.5 font-bold text-sm shadow-lg hover:-translate-y-0.5 transition-all duration-300 disabled:opacity-60"
          style={{ background: 'linear-gradient(90deg, #3A601C, #467322)', boxShadow: '0 8px 20px rgba(70,115,34,0.25)' }}
          data-testid="activate-plan-btn"
        >
          <Power size={16} />
          {activating ? 'Activando...' : 'Activar este plan'}
        </button>
      )}

      {/* Meal time legend */}
      <div className="flex flex-wrap gap-2">
        <div className="flex items-center gap-1.5 bg-amber-50 border border-amber-100 rounded-full px-3 py-1.5">
          <Sun size={13} className="text-amber-500" />
          <span className="text-[11px] font-semibold text-amber-700">Desayuno: 8:00 a.m.</span>
        </div>
        <div className="flex items-center gap-1.5 bg-emerald-50 border border-emerald-100 rounded-full px-3 py-1.5">
          <UtensilsCrossed size={13} className="text-emerald-500" />
          <span className="text-[11px] font-semibold text-emerald-700">Almuerzo</span>
        </div>
        <div className="flex items-center gap-1.5 bg-indigo-50 border border-indigo-100 rounded-full px-3 py-1.5">
          <Moon size={13} className="text-indigo-500" />
          <span className="text-[11px] font-semibold text-indigo-700">Cena: 7:30 - 9:00 p.m.</span>
        </div>
      </div>

      {/* Days */}
      <div className="space-y-3">
        {MEAL_PLAN.map((dayPlan) => {
          const isExpanded = expandedDay === dayPlan.day;
          return (
            <div
              key={dayPlan.day}
              className="bg-white rounded-2xl border border-gray-100/50 overflow-hidden shadow-sm transition-all duration-300"
              data-testid={`day-${dayPlan.day.toLowerCase()}`}
            >
              <button
                onClick={() => toggleDay(dayPlan.day)}
                className="w-full text-left p-4 flex items-center justify-between hover:bg-gray-50/50 transition-colors"
                data-testid={`toggle-${dayPlan.day.toLowerCase()}`}
              >
                <div className="flex items-center gap-3">
                  <div
                    className="w-10 h-10 rounded-xl flex items-center justify-center font-bold text-white text-sm"
                    style={{ backgroundColor: dayPlan.color }}
                  >
                    {dayPlan.day.charAt(0)}
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 text-sm" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                      {dayPlan.day}
                    </p>
                    <p className="text-[11px] text-gray-400">3 comidas</p>
                  </div>
                </div>
                {isExpanded ? (
                  <ChevronUp size={18} className="text-gray-400" />
                ) : (
                  <ChevronDown size={18} className="text-gray-400" />
                )}
              </button>

              {isExpanded && (
                <div className="px-4 pb-4 space-y-3 border-t border-gray-100 pt-3">
                  {dayPlan.meals.map((meal) => {
                    const IconComp = meal.icon;
                    const colors = MEAL_COLORS[meal.type];
                    return (
                      <div
                        key={meal.type}
                        className={`${colors.bg} rounded-xl border ${colors.border} p-3.5`}
                        data-testid={`meal-${dayPlan.day.toLowerCase()}-${meal.type.toLowerCase()}`}
                      >
                        <div className="flex items-center gap-2 mb-2">
                          <IconComp size={14} className={colors.text} />
                          <span className={`text-xs font-bold ${colors.text}`}>{meal.type}</span>
                          {meal.time && (
                            <span className="text-[10px] text-gray-400 font-medium ml-auto">{meal.time}</span>
                          )}
                        </div>
                        <ul className="space-y-1">
                          {meal.items.map((item, i) => (
                            <li key={`meal-item-${i}`} className="flex items-start gap-2">
                              <span className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0" style={{ backgroundColor: dayPlan.color }} />
                              <span className="text-sm text-gray-700">{item}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ClientNutriPlanPage;
